import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-background-100 border border-background-300/50 hover:border-primary-500/50 transition-colors"
      aria-label={`查看《${comic.title}》详情`}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <span className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-full bg-background-50/80 px-2 py-0.5 text-xs text-foreground-200 backdrop-blur">
          {comic.status}
        </span>
        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
          <span className="inline-flex items-center gap-1 text-accent-400 text-sm font-semibold">
            <i className="ri-star-fill text-xs"></i>
            {comic.rating.toFixed(1)}
          </span>
          <span className="text-xs text-foreground-300">{comic.chapters}话</span>
        </div>
      </div>
      <div className="flex flex-col gap-2 p-3 md:p-4 flex-1">
        <h3 className="font-heading text-base md:text-lg text-foreground-950 line-clamp-1 group-hover:text-primary-400 transition-colors">
          {comic.title}
        </h3>
        <div className="flex flex-wrap gap-1.5">
          {comic.tags.slice(0, 3).map((t) => (
            <span
              key={t}
              className="rounded-full bg-secondary-100/70 px-2 py-0.5 text-xs text-secondary-900"
            >
              {t}
            </span>
          ))}
        </div>
        <p className="text-xs text-foreground-700 line-clamp-2 leading-relaxed">{comic.desc}</p>
      </div>
    </Link>
  );
}